import * as sonbp from "sonbp";
import { textItem } from "sonbp/object";
import { itemMani } from ".";
import * as ifbase from "../base";

// -----------------------------------------------
// テキスト独自の操作
// -----------------------------------------------

/**
 * テキストを配置する
 */
export function setText(ifdto: ifbase.ifDto, itemType: string, textIdx: string, json: string, defPosi: { x: number, y: number, w: number, h: number, gen: number }, muki: string, callback: () => void): void {

	var v = ifdto.bpView;
	let exp = (itemType == ifbase.constants.ITYPE_SENDER_TXT) ?
		{
			mode: ifbase.constants.MODE_SENDER_MANI,
			layType: ifbase.constants.LTYPE_SENDER,
			isOnly: true
		} :
		{
			mode: ifbase.constants.MODE_GREETING_MANI,
			layType: ifbase.constants.LTYPE_FREE,
			isOnly: false
		};

	new sonbp.type.promise((resolve, reject) => {

		try {

			let layer = ifbase.util.getLayer(ifdto, exp.layType);
			let items = ifbase.util.getItems(layer.layer.items, function (item): boolean {

				return (item.info.vendor_property.ffpsc?.item_type == itemType);
			});
			let updFlg = exp.isOnly ? items.length > 0: items.filter(d => d.info.vendor_property.ffpsc.idx == textIdx).length > 0

			//JSONをオブジェクトに変換
			let jsonObj = JSON.parse(json);
			let obj = sonbp.util.cast.docCast(jsonObj, sonbp.object.document, true, false, v) as sonbp.object.document;
			let textItem = sonbp.util.obj.doc2group(v, obj);

			let rect = textItem.rect;

			// アスペクト比変更可否の設定
			if (v.initialize.isAspectNg) textItem.info.modeOn(sonbp.constant.editModeType.ASPECT_NG);

			// 元サイズ
			let orgRect = [0, 0, rect.width, rect.height];

			// ベンダープロパティ設定
			textItem.info.vendor_property.ffpsc = {
				item_type: itemType,
				idx: exp.isOnly ? undefined : textIdx,
				org_rect: orgRect,
				muki: muki
			};

			//group配下の個々の文字アイテムは直接編集させない
			let doOpeNg = function (items: sonbp.object.baseItem[]) {
				for (let i = 0; i < items.length; i++) {
					items[i].info.modeOn(sonbp.constant.editModeType.OPERATION_NG);
					items[i].info.modeOn(sonbp.constant.editModeType.ASPECT_NG);

					if (items[i].type == sonbp.constant.itemType.GROUP) {
						doOpeNg((items[i] as sonbp.object.groupItem).childs);
					}
				}
			}
			doOpeNg(textItem.childs);

			//テキストの配置
			if (updFlg) {

				//既存変更
				console.debug("text update.");
				let bfItemId = exp.isOnly ? items[0].id : items.filter(d => d.info.vendor_property.ffpsc.idx == textIdx)[0].id
				setTextUpdate(ifdto, bfItemId, textItem, defPosi);

			} else {

				//初期配置
				console.debug("text append.");
				setTextAppend(ifdto, layer.layer, textItem, defPosi);
			}

			resolve();
		}
		catch (e) {

			reject(e);
		}

	}).then(() => {

		callback();
	}).catch(e => {

		ifdto.callbackError(e);
	});
}

/**
 * テキストアイテムを配置する
 */
function setTextAppend(ifdto: ifbase.ifDto, layer: sonbp.object.layer, textItem: sonbp.object.baseItem, defPosi: { x: number, y: number, w: number, h: number, gen: number }): void {

	let rect = textItem.rect;
	var v = ifdto.bpView;

	let result = v._om.itemAppend(() => {

		//※itemAppendでtry-catchしてるのでここでは不要

		if (defPosi != null) {

			//配置位置指定あり

			if (defPosi.x != null && defPosi.y != null) {
				//位置指定あり
				let px = defPosi.x;
				let py = defPosi.y;

				if (defPosi.gen != null && defPosi.w != null && defPosi.h != null) {

					//x
					switch (defPosi.gen) {
						case 1:
						case 4:
						case 7:
							//左寄せ
							break;
						case 2:
						case 5:
						case 8:
							//中央
							px += (defPosi.w - rect.width) / 2;
							break;
						case 3:
						case 6:
						case 9:
							//右寄せ
							px += defPosi.w - rect.width;
							break;
					}

					//y
					switch (defPosi.gen) {
						case 1:
						case 2:
						case 3:
							//下寄せ
							break;
						case 4:
						case 5:
						case 6:
							//中央
							py += (defPosi.h - rect.height) / 2;
							break;
						case 7:
						case 8:
						case 9:
							//上寄せ
							py += defPosi.h - rect.height;
							break;
					}
				}

				textItem.move(px - rect.x1, py - rect.y1);
			} else {
				//位置指定なし（中央配置）
				let mBox = ifdto.bpView._om._doc.pages[0].size.mediaBoxRect;
				textItem.move((mBox.width - rect.width) / 2 - rect.x1, (mBox.height - rect.height) / 2 - rect.y1);
			}

		} else {

			//配置位置指定なし（等倍中央配置）
			let mBox = ifdto.bpView._om._doc.pages[0].size.mediaBoxRect;
			textItem.move((mBox.width - rect.width) / 2 - rect.x1, (mBox.height - rect.height) / 2 - rect.y1);
		}

		//はみ出しチェック
		itemMani.adjustPosition(ifdto, textItem);

		layer.items.push(textItem);

		let field = sonbp.util.obj.getItemRefById(v, [textItem.id])[0].address;
		var refinfo: sonbp.type.itemRefInfo = { address: field, item: textItem };

		return [refinfo];
	});

	if (!result) {
		throw new Error("v._om.itemAppend result is false.");
	}
}

/**
 * テキストアイテムを変更する。
 */
function setTextUpdate(ifdto: ifbase.ifDto, bfItemId: string, textItem: sonbp.object.baseItem, defPosi: { x: number, y: number, w: number, h: number }): void {

	let rect = textItem.rect;
	var v = ifdto.bpView;

	let itemRefs = sonbp.util.obj.getItemRefById(v, [bfItemId]);

	let result = v._om.layerChange(itemRefs[0].address, (layer: sonbp.object.layer) => {

		//layerChangeでtry-catchしてないのでここで実施
		try {

			let bfItem = itemRefs[0].item;
			let bfRect = bfItem.rect;

			let deg = Number(bfItem.deg ?? 0);
			let rad = sonbp.util.c2d.rad(deg);
			let points = sonbp.util.c2d.getRotatePoints(bfItem.points, -rad, bfItem.points[4]);
			let bfRadRect = sonbp.util.c2d.getRectOfPoints(points);

			if (bfItem.info.vendor_property.ffpsc.muki == textItem.info.vendor_property.ffpsc.muki) {
				//向き同じ

				//向き同じなら、位置・サイズ・角度を引継ぎ
				let sc = Math.min(bfRadRect.width / rect.width, bfRadRect.height / rect.height);
				sc = Math.max(sc, ifbase.constants.TEXT_SCALE_MIN);
				textItem.scale(sc, sc);

				textItem.rotate(deg);

			} else {
				//向き変更

				//向き変わるなら、位置のみ引継ぎ
				if (defPosi != null) {

					let sc = textItem.info.vendor_property.ffpsc.org_rect[2] / rect.width;
					sc = Math.max(sc, ifbase.constants.TEXT_SCALE_MIN);
					textItem.scale(sc, sc);
				}
			}

			rect = textItem.rect;
			textItem.move(bfRect.x1 - rect.x1, bfRect.y1 - rect.y1);

			//はみ出しチェック
			itemMani.adjustPosition(ifdto, textItem);

			//アイテム差替え
			for (let i = 0; i < layer.items.length; i++) {

				if (layer.items[i].id == bfItemId) {

					layer.items[i] = textItem;
					break;
				}
			}

			return true;
		} catch (e) {

			console.error(e);
			return false;
		}
	});

	if (!result) {
		throw new Error("v._om.layerChange result is false.");
	}
}

